import { useState } from "react";
import {
  SELECTED_CATEGORY_TO_TEMPLATE_TYPE_MAP,
  type SelectedCategory,
} from "../TemplateContents";

export const useNavigation = () => {
  const [activeId, setActiveId] = useState<SelectedCategory>("saved_templates");

  const navigationItems = Object.keys(
    SELECTED_CATEGORY_TO_TEMPLATE_TYPE_MAP,
  ) as SelectedCategory[];

  const onClickNavItem = (id: SelectedCategory) => {
    setActiveId(id);
  };

  return {
    activeId,
    navigationItems,
    onClickNavItem,
  };
};
